import { useCallback } from 'react'
import {
  useCallbackConfigurationUpdateMutation,
  type CallbackConfigurationInput,
  FetchPartnerCallbackConfigurationDocument,
} from 'domains/connect/api'
import { usePartnerId } from 'utils/routing/params.hooks'

export interface CallbackConfigurationUpdateMutationProps {
  id: string
  updatedCallbackConfiguration: CallbackConfigurationInput
}

export const usePartnerCallbackConfigurationUpdate = () => {
  const partnerId = usePartnerId()
  const [triggerMutation, { data, loading, error }] = useCallbackConfigurationUpdateMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      { query: FetchPartnerCallbackConfigurationDocument, variables: { id: partnerId } },
    ],
  })

  const updatePartnerCallbackConfiguration = useCallback(
    (args: CallbackConfigurationUpdateMutationProps) => triggerMutation({ variables: { ...args } }),
    [triggerMutation]
  )

  const updatedCallbackConfiguration =
    data && data.callbackConfigurationUpdate.callbackConfiguration

  return {
    updatePartnerCallbackConfiguration,
    updatedCallbackConfiguration,
    loading,
    error,
  }
}
